import * as React from "react";

import "./google-drive-selector-card.scss";

import                        "@Common/libs/google-drive/google-drive";
import {consumeContext}  from "@Common/react/context";
import {ComponentLink,
        Link, makeChain} from "@Common/react/cst2";
import {Load2}           from "@Common/react/load2";
import {UseState}        from "@Common/react/use-state";
import {Types}           from "@Common/types";


export const GoogleDriveSelectorCard = ({
    disallowSvgImages  = false,
    onComplete         = null
}:{
    disallowSvgImages ?: boolean,
    onComplete        ?: () => void
}) => (

    makeChain<JSX.Element>()

    .then(...consumeContext("apis"))
    .then(...consumeContext("systemConstants"))

    // set state vars
    .then("state", (_, next:ComponentLink<typeof UseState<{
        promptDriveFiles  : boolean,
    }>>) => UseState({
        defaultValue: {
            promptDriveFiles: false,
        },
        next
    }))

    // load integrations
    .then("loaderAuthToken", ({state, apis}, next:ComponentLink<typeof Load2<Types.Apis.Payloads.Next.Gallery.IntegrationsGetAuthTokenResponse>>) => Load2({
        fetch: async () => await apis.next.gallery.integrations.getAuthToken({serviceName: "GoogleDrive"}),
        captureException: true,
        next,
    }))

    // render the upload card
    .then(({state, loaderAuthToken, systemConstants}) => (
        <div
            className={"google-drive-selector-card-fd6 card upload"}
        >
            <h2>Select files from Google Drive to add to your gallery.</h2>
            <p className="browse">
                <button onClick={() => state.onChange({...state.value, promptDriveFiles: true})}>Select Files</button>
            </p>
            <p>
                Images must be JPEG (.jpg, .jpeg, .jpe), PNG{disallowSvgImages ? "" : ", SVG"} or PDF format.
            </p>
            {state.value.promptDriveFiles && loaderAuthToken?.value?.authToken && systemConstants.value.GOOGLE_CLIENT_ID && (
                <drive-picker
                    ref={(ref) => {
                        if (!ref) return;
                        ref.addEventListener("picker:canceled", () => state.onChange({...state.value, promptDriveFiles: false}));
                        ref.addEventListener("picker:picked", () => {
                            state.onChange({...state.value, promptDriveFiles: false});
                            onComplete && onComplete();
                        });
                    }}
                    client-id={systemConstants.value.GOOGLE_CLIENT_ID}
                    app-id={systemConstants.value.GOOGLE_CLIENT_ID.split("-")[0]}
                    oauth-token={loaderAuthToken.value.authToken}
                    origin={window.location.protocol + '//' + window.location.host}
                    hide-title-bar="true"
                    max-items="100"
                    nav-hidden="true"
                    multiselect="true"
                >
                    <drive-picker-docs-view
                        view-id="FOLDERS"
                        mode="LIST"
                        include-folders="true"
                        select-folder-enabled="false"
                        mime-types="image/jpeg,image/png,application/pdf,image/svg+xml" // this doesn't actually work, but leaving in place in case Google fixes
                    />
                </drive-picker>
            )}
        </div>
    ))

    .run()

    /*


    */

);
